import React from 'react';
import { List, Map as MapIcon, Search, X } from 'lucide-react';
import { SegmentedTabs } from '../ui/SegmentedTabs';

export const BUILDING_VIEWS = [
  { id: 'list', label: 'List', icon: List },
  { id: 'map',  label: 'Map',  icon: MapIcon },
];

const FilterChip = ({ children, onClear }) => (
  <button
    type="button"
    onClick={onClear}
    className="inline-flex items-center gap-1.5 h-8 pl-3 pr-2 rounded-full border-0 text-[12px] font-medium focus-ring"
    style={{ background: '#fbe9c7', color: '#8a5a1a' }}
    aria-label={`Clear filter: ${children}`}
  >
    {children}
    <X size={13} aria-hidden="true" />
  </button>
);

/**
 * Search, performance filter, active filter chips and the List / Map switch.
 * `band` may also be 'attention' (set from the summary line), which no tab
 * represents, so it shows as a chip instead.
 */
export const BuildingsToolbar = ({
  search,
  onSearchChange,
  band,
  onBandChange,
  bandCounts,
  totalCount,
  epc,
  onClearEpc,
  view,
  onViewChange,
}) => (
  <div className="flex items-center gap-2.5 flex-wrap">
    <label
      className="inline-flex items-center gap-2 h-9 px-3 rounded-[8px] bg-white border border-black/[0.10] min-w-[240px] flex-1 max-w-[320px] focus-within:border-lb-green-accent focus-within:ring-2 focus-within:ring-lb-green-accent/20"
    >
      <Search size={14} className="text-lb-muted flex-shrink-0" aria-hidden="true" />
      <input
        type="search"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search buildings…"
        aria-label="Search buildings"
        className="flex-1 min-w-0 bg-transparent border-0 p-0 outline-none focus-visible:outline-none text-[13px] text-lb-ink placeholder:text-lb-ghost"
      />
    </label>

    {/* Scrolls on its own at phone width instead of widening the page. */}
    <div className="max-w-full overflow-x-auto scrollbar-thin">
      <SegmentedTabs
        ariaLabel="Performance"
        active={band}
        onChange={onBandChange}
        tabs={[
          { id: 'all',  label: 'All',  count: totalCount },
          { id: 'good', label: 'Good', count: bandCounts.good },
          { id: 'fair', label: 'Fair', count: bandCounts.fair },
          { id: 'poor', label: 'Poor', count: bandCounts.poor },
        ]}
      />
    </div>

    {band === 'attention' && <FilterChip onClear={() => onBandChange('all')}>Needs attention</FilterChip>}
    {epc && <FilterChip onClear={onClearEpc}>{`EPC ${epc}`}</FilterChip>}

    <div className="ml-auto">
      <SegmentedTabs
        ariaLabel="View"
        active={view}
        onChange={onViewChange}
        tabs={BUILDING_VIEWS.map(({ id, label, icon: Icon }) => ({
          id,
          label: (
            <span className="inline-flex items-center gap-1.5">
              <Icon size={14} aria-hidden="true" />
              {label}
            </span>
          ),
        }))}
      />
    </div>
  </div>
);
